<template>
  <div>Edit Media Coverage</div>
</template>

<script>
export default {};
</script>